/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ResetColumnSizing({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#ResetColumnSizing_svg__a)"><path d="M2.9 1.5a.6.6 0 0 1 .6-.6h8a.6.6 0 1 1 0 1.2h-8a.6.6 0 0 1-.6-.6ZM1.5 3.4a.6.6 0 0 1 .6.6v8a.6.6 0 1 1-1.2 0V4a.6.6 0 0 1 .6-.6ZM14.5 3.4a.6.6 0 0 1 .6.6v3.5c0 .112-.03.217-.084.306a4.538 4.538 0 0 1 .527 4.457 4.615 4.615 0 0 1-1.721 2.064 4.716 4.716 0 0 1-2.59.773.604.604 0 0 1-.116-.011.603.603 0 0 1-.116.011H3.5a.6.6 0 1 1 0-1.2H11c.04 0 .079.004.116.011a.604.604 0 0 1 .117-.011c.688 0 1.36-.2 1.93-.575a3.415 3.415 0 0 0 1.274-1.527c.262-.62.33-1.302.197-1.96a3.38 3.38 0 0 0-.946-1.739 3.489 3.489 0 0 0-1.777-.933 3.53 3.53 0 0 0-2.008.194 3.453 3.453 0 0 0-1.556 1.255c-.37.544-.57 1.18-.581 1.831l1.199-.68a.61.61 0 0 1 .825.22.59.59 0 0 1-.218.814L7.056 12.23a.61.61 0 0 1-.825-.221L4.778 9.533a.59.59 0 0 1 .218-.813.61.61 0 0 1 .826.22l.752 1.282c.05-.814.319-1.602.78-2.281A4.653 4.653 0 0 1 9.45 6.249a4.73 4.73 0 0 1 4.45.476V4a.6.6 0 0 1 .6-.6Z" /></g><defs><clipPath id="ResetColumnSizing_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;